import * as React from 'react';

import * as styles from './ChatPageLayout.css';

type TProps = {
  date: React.ReactNode;
  messages: React.ReactNode;
  key: string;
};

export const ChatPageLayout: React.FC<TProps> = ({ date, messages, key }) => {
  return (
    <div className={styles['container']} key={key}>
      <div className={styles['date']} data-name="ChatPageLayout_date">
        {date}
      </div>
      <div className={styles['messages']}>{messages}</div>
    </div>
  );
};
